module.exports = __webpack_public_path__ + "img/fresh.03ab98c9.svg";